"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilterConstantName = getFilterConstantName;
exports.getGridConstantName = getGridConstantName;
exports.list = list;
exports.reset = reset;
exports.save = save;
var _CornerstoneMessage = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneMessage"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function getGridConstantName(gridKey) {
  return "grid_".concat(gridKey);
}
function getFilterConstantName() {
  let {
    attributeId,
    attributeType
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return "filter_".concat(attributeId, "_").concat(attributeType);
}
async function list() {
  const {
    gridKey
  } = this.props;
  try {
    if (gridKey && !this.grid().length) {
      await this.props.getGridSettings(gridKey);
    }
  } catch (err) {
    _CornerstoneMessage.default.error(err.message, JSON.parse(localStorage.getItem("toasterOptions")));
  }
}
async function save(userGridColumnList) {
  const {
    gridKey,
    applyUserGridSettings
  } = this.props;
  userGridColumnList.forEach((col, i) => {
    col.columnOrder = i;
    col.columnWidth = parseInt(col.columnWidth);
  });
  try {
    await applyUserGridSettings({
      gridKey,
      userGridColumnList
    });
  } catch (err) {
    _CornerstoneMessage.default.error(err.message);
  }
}
async function reset() {
  const {
    gridKey,
    resetUserGridColumns
  } = this.props;
  try {
    await resetUserGridColumns({
      gridKey
    });
  } catch (err) {
    _CornerstoneMessage.default.error(err.message, JSON.parse(localStorage.getItem("toasterOptions")));
  }
}